export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_USERS':
      return { ...state, users: action.users };
    case 'GET_USERS_CONTRACTS':
      return { ...state, contracts: action.contracts };
    case 'GET_USERS_CONTACTS_SEARCHED':
      return { ...state, searched: action.searched };
    case 'GET_USERS_CONTRACTS_FILTER':
      return { ...state, contractsFilter: action.contracts };
    case 'GET_APPROVE_ID1':
      return { ...state, approveId1: action.payload };
    case 'GET_APPROVE_ID2':
      return { ...state, approveId2: action.payload };
    case 'GET_APPROVE_EMAIL1':
      return { ...state, approveEmail1: action.payload };
    case 'GET_APPROVE_EMAIL2':
      return { ...state, approveEmail2: action.payload };
    case 'GET_USERS_PERMISSIONS_DELETE_APPROVERS':
      return { ...state, usersPermissionsDeleteApprovers: action.usersPermissionsDeleteApprovers };
    default:
      return state;
  }
};
